import _ from 'lodashParts'
import constants from '../utils/constants'
import {normalizeCssFontFamily} from '../utils/fontUtils'
import {decodeDataQuery, encodeDataQuery} from '../utils/linkUtils'
import shadowUtils from '../utils/shadowUtils'

function getNormalizedFont(fontFamily, propsCollector) {
    const normalizedCssFontFamily = normalizeCssFontFamily(fontFamily)

    const fonts = propsCollector.getNormalizedFonts() || {}

    return _.get(fonts[normalizedCssFontFamily], 'fontFamily') || normalizedCssFontFamily
}
const cmdIntVal = cmdState => parseInt(cmdState, 10)
const cmdBoolVal = cmdState => parseInt(cmdState, 10) === 1
const cmdStringVal = cmdState => typeof cmdState === 'string' ? cmdState : ''
const cmdFontFamily = (cmdState, propsCollector) => getNormalizedFont(cmdState, propsCollector)
const cmdFormatBlock = cmdState => {
    let retVal = cmdState
    if (cmdState) {
        retVal = Object.create({toString: () => cmdState.class})//eslint-disable-line
        _.assign(retVal, cmdState)
    }
    return retVal
}
const cmdLinksDecode = cmdState => {
    if (typeof cmdState === 'number') {
        return cmdState
    }
    return decodeDataQuery(cmdState)
}
const boldExecCommand = (cmdName, params, cmdOptions, {propsCollector, lastCommandStates, execCommand}) => {
    if (cmdName === 'bold' && _.get(propsCollector.getCachedThemes()[lastCommandStates.formatBlock], 'bold')) {
        cmdName = 'unBold'
    }
    execCommand(cmdName, params, cmdOptions)
}
const italicExecCommand = (cmdName, params, cmdOptions, {propsCollector, lastCommandStates, execCommand}) => {
    if (cmdName === 'italic' && _.get(propsCollector.getCachedThemes()[lastCommandStates.formatBlock], 'italic')) {
        cmdName = 'unItalic'
    }
    execCommand(cmdName, params, cmdOptions)
}
const wixLinkExecCommand = (cmdName, params, cmdOptions, {execCommand, lastCommandStates}) => {
    if (lastCommandStates.wixLink === constants.TRISTATE_DISABLED) {
        return
    }

    if (cmdName === 'wixLink') {
        params = {dataquery: encodeDataQuery(params)}
    }
    execCommand(cmdName, params, cmdOptions)
}
const fontFamilyExecCommand = (cmdName, params, cmdOptions, {propsCollector, execCommand}) => {
    const fonts = propsCollector.getNormalizedFonts() || {}
    const fontFamilyObj = _.find(fonts, {fontFamily: params})
    const fontFamily = _.get(fontFamilyObj, 'cssFontFamily') || ''

    execCommand(cmdName, fontFamily, cmdOptions)

}

const execAndTriggerStateCheck = (cmdName, params, cmdOptions, {calculateCommandStates, execCommand}) => {
    execCommand(cmdName, params, cmdOptions)
    calculateCommandStates([cmdName])
}

const textShadowCommmand = (cmdName, params, cmdOptions, {execCommand}) => {
    if (cmdName === 'textShadow') {
        params = constants.EFFECTS[params] && constants.EFFECTS[params].cssData
    }

    if (params) {
        execCommand(cmdName, params, cmdOptions)
    }
}
const textShadowVal = cmdState => {
    if (cmdState !== constants.TRISTATE_OFF) {
        const foundEffect = _.findKey(constants.EFFECTS, effect => {
            if (effect.cssData !== constants.TRISTATE_OFF) {
                return shadowUtils.cssTextShadowCompare(effect.cssData, cmdState)
            }
        })

        if (foundEffect) {
            return foundEffect
        }
    }

    return 'EFFECT_0'
}

const commands = {
    formatBlock: {transformValue: cmdFormatBlock},
    bold: {transformValue: cmdBoolVal, execCommand: boldExecCommand},
    unBold: {transformValue: cmdBoolVal},
    italic: {transformValue: cmdBoolVal, execCommand: italicExecCommand},
    unItalic: {transformValue: cmdBoolVal},
    underline: {transformValue: cmdBoolVal},
    outdent: {transformValue: cmdIntVal},
    indent: {transformValue: cmdIntVal},
    bidiltr: {transformValue: cmdBoolVal},
    bidirtl: {transformValue: cmdBoolVal},
    justifyleft: {transformValue: cmdBoolVal},
    justifyright: {transformValue: cmdBoolVal},
    justifycenter: {transformValue: cmdBoolVal},
    justifyblock: {transformValue: cmdBoolVal},
    numberedlist: {transformValue: cmdBoolVal},
    bulletedlist: {transformValue: cmdBoolVal},
    fontSize: {transformValue: cmdIntVal},
    foreColor: {transformValue: cmdStringVal},
    backColor: {transformValue: cmdStringVal},
    letterSpacing: {transformValue: cmdStringVal},
    lineHeight: {transformValue: cmdStringVal, execCommand: execAndTriggerStateCheck},
    fontFamily: {transformValue: cmdFontFamily, execCommand: fontFamilyExecCommand},
    wixLink: {transformValue: cmdLinksDecode, execCommand: wixLinkExecCommand},
    textShadow: {transformValue: textShadowVal, execCommand: textShadowCommmand}
}

const fixBoldCmdState = (cmdStates, themeObj) => {
    if (themeObj.bold) {
        cmdStates.bold = !cmdStates.unBold
    }
}
const fixItalicCmdState = (cmdStates, themeObj) => {
    if (themeObj.italic) {
        cmdStates.italic = !cmdStates.unItalic
    }
}
function extractThemeColor(themeColor) {
    const siteColor = themeColor.match('\{(.*?)\}')

    return siteColor ? siteColor[1] : themeColor
}

const fixColorCmd = (cmdStates, themeObj) => {
    if (cmdStates.foreColor === '' && themeObj.color) {
        cmdStates.foreColor = extractThemeColor(themeObj.color)
    }
}
const fixFontSizeCmd = (cmdStates, themeObj) => {
    if (cmdStates.fontSize === constants.TRISTATE_OFF && themeObj.size) {
        cmdStates.fontSize = cmdIntVal(themeObj.size)
    }
}
const fixFontFamilyCmd = (cmdStates, themeObj, propsCollectors) => {
    if ((!cmdStates.fontFamily || cmdStates.fontFamily === constants.TRISTATE_OFF) && themeObj.fontWithFallbacks) {
        cmdStates.fontFamily = getNormalizedFont(themeObj.fontWithFallbacks, propsCollectors)
    }
}

const commandsDependentOnTheme = [
    {name: 'fontFamily', transformValue: fixFontFamilyCmd},
    {name: 'fontSize', transformValue: fixFontSizeCmd},
    {name: 'bold', transformValue: fixBoldCmdState},
    {name: 'italic', transformValue: fixItalicCmdState},
    {name: 'foreColor', transformValue: fixColorCmd}
]

const getCommandsStates = ({engineAdapter, propsCollector, commandsToCheck = []}) => {
    const retVal = {}

    const shouldAlwaysCheckCommand = _.isEmpty(commandsToCheck)
    _.forEach(commands, (cmdValue, cmdName) => {
        if (shouldAlwaysCheckCommand || _.includes(commandsToCheck, cmdName)) {
            const cmdState = engineAdapter.getCmdState(cmdName)
            retVal[cmdName] = cmdValue.transformValue(cmdState, propsCollector)
        }
    })

    if (retVal.formatBlock && propsCollector.getCachedThemes()[retVal.formatBlock]) {
        _.forEach(commandsDependentOnTheme, cmd => {
            if (shouldAlwaysCheckCommand || _.includes(commandsToCheck, cmd.name)) {
                cmd.transformValue(retVal, propsCollector.getCachedThemes()[retVal.formatBlock], propsCollector)
            }
        })
    }

    return retVal
}
function init(privates) {
    const {propsCollector, engineAdapter, calculateCommandStates} = privates
    this.execCommand = (cmdName, params, options) => {
        //todo if !engineAdapter.hasCommand(cmdName) -- find command by displayName
        const execCommandFunc = _.get(commands, `${cmdName}.execCommand`) || engineAdapter.execCmd
        execCommandFunc(cmdName, params, options, {
            execCommand: engineAdapter.execCmd,
            propsCollector,
            lastCommandStates: privates.lastCommandStates,
            calculateCommandStates
        })
    }

    this.commands = {}
    //todo move stateless commands into cmdUtils, add all relevant commands(selectAll, wixCss, ...)
    const stateLessCommands = {
        wixSelectLinks: {displayName: 'expandCurrentLinkSelection'},
        selectAll: {},
        wixUnlink: {},
        wixCss: {},
        resetTheme: {},
        resetThemeAndStyles: {},
        toUpperCase: {},
        autogrow: {}
    }
    _.forEach({...stateLessCommands, ...commands}, (value, key) => {
        const name = value.displayName || key
        this.commands[name] = (...args) => this.execCommand(key, ...args)
    })
    this.resetTheme = () => {
        console.warn('manager.resetTheme() is deprecated. Use manager.commands.resetTheme() or manager.execCommand(\'resetTheme\') instead')
        this.execCommand('resetTheme')
    }
    this.resetThemeAndStyles = () => {
        console.warn('manager.resetThemeAndStyles() is deprecated. Use manager.commands.resetThemeAndStyles() or manager.execCommand(\'resetThemeAndStyles\') instead')
        this.execCommand('resetThemeAndStyles')
    }
    this.expandCurrentLinkSelection = () => {
        console.warn('manager.expandCurrentLinkSelection() is deprecated. Use manager.commands.expandCurrentLinkSelection() or manager.execCommand(\'expandCurrentLinkSelection\') instead')
        this.execCommand('wixSelectLinks')
    }
    this.selectAll = () => {
        console.warn('manager.selectAll() is deprecated. Use manager.commands.selectAll() or manager.execCommand(\'selectAll\') instead')
        this.execCommand('selectAll')
    }
}

module.exports = {
    commands,
    commandsDependentOnTheme,
    getCommandsStates,
    init
}



// WEBPACK FOOTER //
// ./src/mainController/mainControllerCommands.js